import { AuxiliumComponent } from "../auxilium-component";

export default class Prompt extends AuxiliumComponent {
	static observable = ["size", "icon", "heading"];

	parsedCallback() {
		this.appendChild(document.createElementWithContents("div", this.childNodes, { className: "prompt__description" }));

		if (this.heading) { this.prepend(document.createElementWithContents("div", this.heading, { className: "prompt__title" })); }
		if (this.icon) { this.prepend(document.createElementWithContents("div", document.createElementWithContents("chip-icon", null, { icon: this.icon }), { className: "prompt__icon" })); }
	}

	attributeChanged(name, _, newValue) {
		if (name === "icon") {
			let element = this.querySelector(".prompt__icon");

			if (!element) {
				element = document.createElementWithContents("div", document.createElementWithContents("div", document.createElementWithContents("chip-icon", null, { icon: this.icon }), { className: "prompt__icon" }));
			}

			element.querySelector("chip-icon").icon = newValue;
		}
	}
}
